import * as React from 'react';
export function createProvider(context, configScopes, initiateState, configScopeTransformer) {
    return (props) => {
        const [loading, setLoading] = React.useState(true);
        const [contextState, setContextState] = React.useState();
        React.useEffect(() => {
            (async () => {
                const config = await initConfig(props.envConfigService, configScopes, configScopeTransformer);
                if (initiateState) {
                    setContextState(await initiateState(props, config));
                }
                else {
                    setContextState({ config });
                }
                setLoading(false);
            })();
        }, []);
        if (loading || !contextState) {
            return null;
        }
        return React.createElement(context.Provider, { value: contextState }, props.children);
    };
}
async function initConfig(envConfigService, configScopes, configScopeTransformer) {
    const resultingConfigs = {};
    await Promise.all(configScopes.map((scope) => envConfigService
        .getConfiguration(configScopeTransformer ? configScopeTransformer(scope) : scope)
        .then((config) => {
        if (!config) {
            throw new Error(`Env config "${scope}" is missing`);
        }
        resultingConfigs[scope] = config;
    })));
    return resultingConfigs;
}
//# sourceMappingURL=create-provider.js.map